import classNames from 'classnames/bind';
import React, { FC, ReactElement, ReactNode, Suspense } from 'react';
import { v4 as uuid } from 'uuid';

import { Info } from '../../assets/icons/Icons';
import styles from './Tooltip.module.scss';

const ReactToolTip = React.lazy(() => import('react-tooltip'));

const cx = classNames.bind(styles);

export const TOOLTIP_POSITION = {
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left',
};

interface Props {
  infoIcon?: boolean;
  position?: 'top' | 'right' | 'bottom' | 'left';
  content: string | ReactElement;
  disabled?: boolean;
  children?: ReactNode;
  className?: string;
  showOnClick?: boolean;
  offset?: any;
  fullWidth?: boolean;
  noMaxWidth?: boolean;
}

const Tooltip: FC<Props> = ({
  infoIcon,
  position = 'right',
  content,
  disabled,
  children,
  showOnClick,
  offset,
  className,
  fullWidth = false,
  noMaxWidth = false,
}) => {
  const dataForId = uuid();

  // info icon has a 2px padding along the bottom. this ensures proper vertical alignment
  const useOffset = infoIcon && (position === TOOLTIP_POSITION.RIGHT || position === TOOLTIP_POSITION.LEFT);

  return (
    <>
      <span
        data-tip={showOnClick ? 'custom show' : ''}
        data-event={showOnClick ? 'click focus' : ''}
        data-for={dataForId}
        aria-describedby={dataForId}
        data-testid='tooltip'>
        {infoIcon ? <span className={cx('info-icon')}>{Info}</span> : children}
      </span>
      <Suspense>
        <ReactToolTip
          offset={(offset ?? useOffset) ? { top: 2 } : {}} // fixes vertical alignment
          id={dataForId}
          clickable={showOnClick}
          globalEventOff={showOnClick ? 'click' : undefined}
          multiline={true}
          effect='solid'
          place={position}
          delayShow={0}
          className={cx('tooltip', className, {
            'tooltip--full-width': fullWidth,
            'tooltip--no-max-width': noMaxWidth,
          })}
          disable={disabled}
          wrapper={'span'}
          role='tooltip'>
          {content}
        </ReactToolTip>
      </Suspense>
    </>
  );
};

export default Tooltip;
